import React, { useEffect, Fragment, useState } from 'react';
import { Form, Tag, Spin, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import DetailTitle from '../DetailTitle';
import './index.less';

const api = services.api;

// 商品经营管理详情-标签
const ProductGoodsInfoDetailView = (props: any) => {
    const queryParams = new URLSearchParams(props.location.search);
    const skuCode = queryParams.get('skuCode');
    const [loading, setLoading] = useState(false);
    const [coreTags, setCoreTags] = useState<string[]>([]); // 核心标签
    const [extendedTags, setExtendedTags] = useState<string[]>([]); // 扩展标签
    // 获取详情信息
    const handlleGetDetail = () => {
        setLoading(true);
        api.get({}, { apiPath: `/searchTag/tagIndex/${skuCode}` })
            .then((res: any) => {
                if (res.resultCode === 200) {
                    const resultBody = res.resultBody || {};
                    setCoreTags(resultBody.flatCoreTagValues || []);
                    setExtendedTags(resultBody.flatExtendedTagValues || []);
                }
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };
    const goBack = () => {
        services.navigation.goto('/product/goods');
    };
    useEffect(() => {
        handlleGetDetail();
    }, []);

    return (
        <>
            <Fragment>
                <Spin spinning={loading}>
                    <DetailTitle label={'核心标签'} />
                    <div className="tagsWrap">
                        {coreTags.map((item: any, index: number) => {
                            return (
                                <Tag className="tagItem1" key={index}>
                                    {item}
                                </Tag>
                            );
                        })}
                        {coreTags.length === 0 && <div className="noTags">暂无标签</div>}
                    </div>
                    <DetailTitle label={'扩展标签'} />
                    <div className="tagsWrap">
                        {extendedTags.map((item: any, index: number) => {
                            return (
                                <Tag className="tagItem2" key={index}>
                                    {item}
                                </Tag>
                            );
                        })}
                        {extendedTags.length === 0 && <div className="noTags">暂无标签</div>}
                    </div>
                    <div
                        className="footer-btn"
                        style={{ marginBottom: 20, marginTop: 20, textAlign: 'right' }}
                    >
                        <Button onClick={goBack}>返回</Button>
                    </div>
                </Spin>
            </Fragment>
        </>
    );
};

export const ProductGoodsDetailTags = Form.create()(ProductGoodsInfoDetailView);
